import React from 'react';
export default function headerRenderer(columns) {
  return React.createElement("tr", {
    key: "columns"
  }, columns);
}